import React from 'react';

import AutoLogoutBanner from 'corgi/auto-logout-banner/components/AutoLogoutBanner';
import { Flex } from 'corgi/common/components/Flex';
import { AUTO_LOGOUT_BANNER_Z_INDEX } from 'corgi/common/constants/z-index';

export const LogoutBanner = () => (
  <Flex
    position="sticky"
    padding="sp_0"
    themeTop="sp_0"
    zIndex={AUTO_LOGOUT_BANNER_Z_INDEX}
    width="100%"
    boxSizing="border-box"
  >
    <AutoLogoutBanner />
  </Flex>
);
